import PageHeader from "@/components/PageHeader";
import Field from "@/components/fields/Field";
import { SelectOption } from "@/components/inputs/Select";

export interface Contributor {
  id: number;
  first_name: string;
  middle_name?: string;
  last_name: string;
  full_name: string;
  ipi_cae_number?: string;
  pro_affiliation?: string;
  nro_affiliation?: string;
  nro_number?: string;
  created_at: Date;
}

interface ShowProps {
  contributor: Contributor;
  linked_user: SelectOption | null;
}

const Show: React.FC<ShowProps> = ({ contributor, linked_user }) => {
  return (
    <div className="flex w-full flex-col items-start justify-start gap-5 md:gap-10">
      <PageHeader
        backLink={{ href: "/contributors", text: "Back to all contributors" }}
        title={contributor.full_name}
        primaryAction={{
          href: `/contributors/${contributor.id}/edit`,
          text: "Edit",
        }}
      />
      <div className="dark:bg-cream-950 flex w-full flex-col gap-6 rounded-2xl bg-white p-6 shadow md:p-10">
        <Field label="First Name" value={contributor.first_name} />
        <Field label="Middle Name" value={contributor.middle_name} />
        <Field label="Last Name" value={contributor.last_name} />
        <Field label="PRO Affiliation" value={contributor.pro_affiliation} />
        <Field label="IPI/CAE Number" value={contributor.ipi_cae_number} />
        <Field label="NRO Affiliation" value={contributor.nro_affiliation} />
        <Field label="NRO Number" value={contributor.nro_number} />
        <Field label="Linked User" value={linked_user?.label} />
      </div>
    </div>
  );
};

export default Show;
